import request from '@/utils/request';


// 收藏列表
export function GetPage(params) {
  return request({
    url: '/api/good/collection/page',
    method: 'GET',
    params: params
  });
}

// 取消收藏
export function Cancel(params) {
  return request({
    url: '/api/good/collection/delete',
    method: 'GET',
    params: params
  });
}